import React, { Component } from "react";
import Button from 'react-bootstrap/Button';

class GolfUpdateRowInactive extends Component {
  handleAddTimeslot = event => {
    console.log("handleTimeSlothandler: ");
    console.log(event);
    this.props.handleAddTimeslot(event);
    console.log("Timeslot added");
  };
  
  render() {
    return (

      <tr>      
        <td>
          <label className="form-check-label" htmlFor="defaultCheck1 p-2">
            {this.props.golf}
          </label>
        </td>
        <td>
          {this.props.status ? this.props.tp ? (<span className="badge badge-warning">TMZ Only</span>): (
            <span className="badge badge-success">Active</span>
          ) : (
            <span className="badge badge-secondary ml-2">Not Active</span>
          )}
        </td>

        <td>
        <Button 
          key={this.props.golf+this.props.day}
          variant="link"
          onClick={() => this.handleAddTimeslot({ golf: this.props.golf, day: this.props.day })}
          >Add</Button>

        </td>

        <td>
        </td>
        

        <td>
        </td>

        <td>
        </td>
        <td>
        </td>
        <td>
        </td>
        <td>
        </td>
        <td>
        </td>
      </tr>
    );
  }
}

export default GolfUpdateRowInactive;
